import {BaseConverter} from "../../base/converters/base-converter.converter";
import {DraftOperatorModel} from "../models/draft-operator.model";
import {DraftOperator} from "../../shared/DTO/draftOperator";
import {Injectable} from "@angular/core";

@Injectable()
export class DraftOperatorConverter extends BaseConverter<DraftOperatorModel, DraftOperator> {
  convertToDto(model: DraftOperatorModel): DraftOperator {
    if (!model) {
      return;
    }
    return {
      appId: model.appId,
      identityId: model.identityId,
      uida: model.uida,
      unit: model.unit
    };
  }

  convertToModel(dto: DraftOperator): DraftOperatorModel {
    if (!dto) {
      return;
    }
    let model: DraftOperatorModel = new DraftOperatorModel();
    model.unit = dto.unit;
    model.uida = dto.uida;
    model.identityId = dto.identityId;
    model.appId = dto.appId;

    return model;
  }

}
